function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createVNode as _createVNode } from "vue";
import { ref, watch, reactive, computed, onMounted, onActivated, onDeactivated, onBeforeUnmount, defineComponent, nextTick } from "vue";
import { clamp, isHidden, truthProp, numericProp, windowWidth, windowHeight, preventDefault, createNamespace, makeNumericProp } from "../utils";
import { doubleRaf, useChildren, usePageVisibility } from "@vant/use";
import { useTouch } from "../composables/use-touch";
import { useExpose } from "../composables/use-expose";
import { onPopupReopen } from "../composables/on-popup-reopen";

var _createNamespace = createNamespace("swipe"),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

var swipeProps = {
  loop: truthProp,
  width: numericProp,
  height: numericProp,
  vertical: Boolean,
  autoplay: makeNumericProp(0),
  duration: makeNumericProp(500),
  touchable: truthProp,
  lazyRender: Boolean,
  initialSwipe: makeNumericProp(0),
  indicatorColor: String,
  showIndicators: truthProp,
  stopPropagation: truthProp
};
var SWIPE_KEY = Symbol(name);
var stdin_default = defineComponent({
  name: name,
  props: swipeProps,
  emits: ["change"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots;
    var root = ref();
    var state = reactive({
      rect: null,
      width: 0,
      height: 0,
      offset: 0,
      active: 0,
      swiping: false
    });
    var touch = useTouch();

    var _useChildren = useChildren(SWIPE_KEY),
        children = _useChildren.children,
        linkChildren = _useChildren.linkChildren;

    var count = computed(function () {
      return children.length;
    });
    var size = computed(function () {
      return state[props.vertical ? "height" : "width"];
    });
    var delta = computed(function () {
      return props.vertical ? touch.deltaY.value : touch.deltaX.value;
    });
    var minOffset = computed(function () {
      if (state.rect) {
        var base = props.vertical ? state.rect.height : state.rect.width;
        return base - size.value * count.value;
      }

      return 0;
    });
    var maxCount = computed(function () {
      return Math.ceil(Math.abs(minOffset.value) / size.value);
    });
    var trackSize = computed(function () {
      return count.value * size.value;
    });
    var activeIndicator = computed(function () {
      return (state.active + count.value) % count.value;
    });
    var isCorrectDirection = computed(function () {
      var expect = props.vertical ? "vertical" : "horizontal";
      return touch.direction.value === expect;
    });
    var trackStyle = computed(function () {
      var style = {
        transitionDuration: "".concat(state.swiping ? 0 : props.duration, "ms"),
        transform: "translate".concat(props.vertical ? "Y" : "X", "(").concat(state.offset, "px)")
      };

      if (size.value) {
        var mainAxis = props.vertical ? "height" : "width";
        var crossAxis = props.vertical ? "width" : "height";
        style[mainAxis] = "".concat(trackSize.value, "px");
        style[crossAxis] = props[crossAxis] ? "".concat(props[crossAxis], "px") : "";
      }

      return style;
    });

    var getTargetActive = function getTargetActive(pace) {
      var active = state.active;

      if (pace) {
        if (props.loop) {
          return clamp(active + pace, -1, count.value);
        }

        return clamp(active + pace, 0, maxCount.value);
      }

      return active;
    };

    var getTargetOffset = function getTargetOffset(targetActive) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var currentPosition = targetActive * size.value;

      if (!props.loop) {
        currentPosition = Math.min(currentPosition, -minOffset.value);
      }

      var targetOffset = offset - currentPosition;

      if (!props.loop) {
        targetOffset = clamp(targetOffset, minOffset.value, 0);
      }

      return targetOffset;
    };

    var move = function move(_ref2) {
      var _ref2$pace = _ref2.pace,
          pace = _ref2$pace === void 0 ? 0 : _ref2$pace,
          _ref2$offset = _ref2.offset,
          offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
          emitChange = _ref2.emitChange;

      if (count.value <= 1) {
        return;
      }

      var active = state.active;
      var targetActive = getTargetActive(pace);
      var targetOffset = getTargetOffset(targetActive, offset);

      if (props.loop) {
        if (children[0] && targetOffset !== minOffset.value) {
          var outRightBound = targetOffset < minOffset.value;
          children[0].setOffset(outRightBound ? trackSize.value : 0);
        }

        if (children[count.value - 1] && targetOffset !== 0) {
          var outLeftBound = targetOffset > 0;
          children[count.value - 1].setOffset(outLeftBound ? -trackSize.value : 0);
        }
      }

      state.active = targetActive;
      state.offset = targetOffset;

      if (emitChange && targetActive !== active) {
        emit("change", activeIndicator.value);
      }
    };

    var correctPosition = function correctPosition() {
      state.swiping = true;

      if (state.active <= -1) {
        move({
          pace: count.value
        });
      } else if (state.active >= count.value) {
        move({
          pace: -count.value
        });
      }
    };

    var prev = function prev() {
      correctPosition();
      touch.reset();
      doubleRaf(function () {
        state.swiping = false;
        move({
          pace: -1,
          emitChange: true
        });
      });
    };

    var next = function next() {
      correctPosition();
      touch.reset();
      doubleRaf(function () {
        state.swiping = false;
        move({
          pace: 1,
          emitChange: true
        });
      });
    };

    var autoplayTimer;

    var stopAutoplay = function stopAutoplay() {
      return clearTimeout(autoplayTimer);
    };

    var autoplay = function autoplay() {
      stopAutoplay();

      if (props.autoplay > 0 && count.value > 1) {
        autoplayTimer = setTimeout(function () {
          next();
          autoplay();
        }, +props.autoplay);
      }
    };

    var initialize = function initialize() {
      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : +props.initialSwipe;

      if (!root.value) {
        return;
      }

      var cb = function cb() {
        var _a, _b;

        if (!isHidden(root)) {
          var rect = {
            width: root.value.offsetWidth,
            height: root.value.offsetHeight
          };
          state.rect = rect;
          state.width = +((_a = props.width) != null ? _a : rect.width);
          state.height = +((_b = props.height) != null ? _b : rect.height);
        }

        if (count.value) {
          active = Math.min(count.value - 1, active);
        }

        state.active = active;
        state.swiping = true;
        state.offset = getTargetOffset(active);
        children.forEach(function (swipe) {
          swipe.setOffset(0);
        });
        autoplay();
      };

      if (isHidden(root)) {
        nextTick().then(cb);
      } else {
        cb();
      }
    };

    var resize = function resize() {
      return initialize(state.active);
    };

    var touchStartTime;

    var onTouchStart = function onTouchStart(event) {
      if (!props.touchable) return;
      touch.start(event);
      touchStartTime = Date.now();
      stopAutoplay();
      correctPosition();
    };

    var onTouchMove = function onTouchMove(event) {
      if (props.touchable && state.swiping) {
        touch.move(event);

        if (isCorrectDirection.value) {
          preventDefault(event, props.stopPropagation);
          move({
            offset: delta.value
          });
        }
      }
    };

    var onTouchEnd = function onTouchEnd() {
      if (!props.touchable || !state.swiping) {
        return;
      }

      var duration = Date.now() - touchStartTime;
      var speed = delta.value / duration;
      var shouldSwipe = Math.abs(speed) > 0.25 || Math.abs(delta.value) > size.value / 2;

      if (shouldSwipe && isCorrectDirection.value) {
        var offset = props.vertical ? touch.offsetY.value : touch.offsetX.value;
        var pace = 0;

        if (props.loop) {
          pace = offset > 0 ? delta.value > 0 ? -1 : 1 : 0;
        } else {
          pace = -Math[delta.value > 0 ? "ceil" : "floor"](delta.value / size.value);
        }

        move({
          pace: pace,
          emitChange: true
        });
      } else if (delta.value) {
        move({
          pace: 0
        });
      }

      state.swiping = false;
      autoplay();
    };

    var swipeTo = function swipeTo(index) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      correctPosition();
      touch.reset();
      doubleRaf(function () {
        var targetIndex;

        if (props.loop && index === count.value) {
          targetIndex = state.active === 0 ? 0 : index;
        } else {
          targetIndex = index % count.value;
        }

        if (options.immediate) {
          doubleRaf(function () {
            state.swiping = false;
          });
        } else {
          state.swiping = false;
        }

        move({
          pace: targetIndex - state.active,
          emitChange: true
        });
      });
    };

    var renderDot = function renderDot(_, index) {
      var active = index === activeIndicator.value;
      var style = active ? {
        backgroundColor: props.indicatorColor
      } : void 0;
      return _createVNode("i", {
        "style": style,
        "class": bem("indicator", {
          active: active
        })
      }, null);
    };

    var renderIndicator = function renderIndicator() {
      if (slots.indicator) {
        return slots.indicator({
          active: activeIndicator.value,
          total: count.value
        });
      }

      if (props.showIndicators && count.value > 1) {
        return _createVNode("div", {
          "class": bem("indicators", {
            vertical: props.vertical
          })
        }, [Array(count.value).fill("").map(renderDot)]);
      }
    };

    useExpose({
      prev: prev,
      next: next,
      state: state,
      resize: resize,
      swipeTo: swipeTo
    });
    linkChildren({
      size: size,
      props: props,
      count: count,
      activeIndicator: activeIndicator
    });
    watch(function () {
      return props.initialSwipe;
    }, function (value) {
      return initialize(+value);
    });
    watch(count, function () {
      return initialize(state.active);
    });
    watch(function () {
      return props.autoplay;
    }, autoplay);
    watch([windowWidth, windowHeight], resize);
    watch(usePageVisibility(), function (visible) {
      if (visible === "visible") {
        autoplay();
      } else {
        stopAutoplay();
      }
    });
    onMounted(initialize);
    onActivated(function () {
      return initialize(state.active);
    });
    onPopupReopen(function () {
      return initialize(state.active);
    });
    onDeactivated(stopAutoplay);
    onBeforeUnmount(stopAutoplay);
    return function () {
      var _a;

      return _createVNode("div", {
        "ref": root,
        "class": bem()
      }, [_createVNode("div", {
        "style": trackStyle.value,
        "class": bem("track", {
          vertical: props.vertical
        }),
        "onTouchstart": onTouchStart,
        "onTouchmove": onTouchMove,
        "onTouchend": onTouchEnd,
        "onTouchcancel": onTouchEnd
      }, [(_a = slots["default"]) == null ? void 0 : _a.call(slots)]), renderIndicator()]);
    };
  }
});
export { SWIPE_KEY, stdin_default as default };